import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { APIRequestStatus } from "common-ts/dist/models/APIRequestStatus";

const initialState : {
    orderObject: any | null,
    status: APIRequestStatus,
    error: string | null,
} = {
    orderObject: null,
    status: APIRequestStatus.Idle,
    error: null
}

export const fetchOrderPublic = createAsyncThunk('orderState/fetchOrderPublic',
    async (orderId: string, thunkAPI) => {
        const response = await axios({
            method: 'get',
            url: 'https://8mav2hp6ki.execute-api.ap-southeast-1.amazonaws.com/OrderAPIProduction/order-public',
            params: {
                orderId: orderId
            }
        });

        return response.data;
    }
)

export const postOrderLabelNamaUpdate = createAsyncThunk('orderState/postOrderLabelNamaUpdate', async (arg: {userSub: string, creationDateTime: string, labelNamaManualArray: string[], defaultLabelNama: string | undefined}, thunkAPI) => {
    // Update order REPEAT RESPONSE 
    const response = await axios({
        method: 'post',
        url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/order', // Endpoint for order update
        data: {
            userSub: arg.userSub,
            creationDateTime: arg.creationDateTime,
            updateType: "labelNamaUpdate",
            labelNamaManualArray: arg.labelNamaManualArray ?? [],
            defaultLabelNama: arg?.defaultLabelNama ? arg.defaultLabelNama : undefined,
        }
    });

    return response.data
})

export const orderStateSlice = createSlice({
    name: 'orderState',
    initialState,
    reducers: {
    },
    extraReducers(builder) {
        builder
            .addCase(fetchOrderPublic.pending, (state, action) => {
                state.status = APIRequestStatus.RequestInProgress;
            })
            .addCase(fetchOrderPublic.fulfilled, (state, action) => {
                state.status = APIRequestStatus.Success;

                state.orderObject = action.payload
            })
            .addCase(fetchOrderPublic.rejected, (state, action) => {
                state.status = APIRequestStatus.Failure;
            })
            .addCase(postOrderLabelNamaUpdate.pending, (state, action) => {
                state.status = APIRequestStatus.RequestInProgress;
            })
            .addCase(postOrderLabelNamaUpdate.fulfilled, (state, action) => {
                state.status = APIRequestStatus.Success;

                if (state.orderObject) {
                    state.orderObject = {
                        ...state.orderObject,
                        labelNamaManualArray: action.meta.arg.labelNamaManualArray
                    };
                }
            })
            .addCase(postOrderLabelNamaUpdate.rejected, (state, action) => {
                state.status = APIRequestStatus.Failure;
            })
    },
})

export default orderStateSlice.reducer